import { render, staticRenderFns } from "./HomeTitleBlock.vue?vue&type=template&id=78819bbc"
import script from "./HomeTitleBlock.vue?vue&type=script&lang=js"
export * from "./HomeTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./HomeTitleBlock.vue?vue&type=style&index=0&id=78819bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports